<section class="sign-off-summary" data-testid="data-terminal-sign-off-summary">
    <p>
        {{ 'DC.SIGN_OFF_DIALOG.SUMMARY.DESCRIPTION' | translate }}
    </p>
    <div class="sign-off-summary__list-of-summary-cards">
        @for (signOff of signOffMachines; track signOff.machineId) {
            <data-terminal-sign-off-summary-card
                class="hdmui-m-3"
                [signOffMachine]="signOff"
                data-testid="data-terminal-sign-off-summary-card"
            ></data-terminal-sign-off-summary-card>
        }
    </div>
</section>
